import { create } from 'zustand';
import { VersionsState, VersionsAction } from './versions.type';

const initialState: VersionsState = {
  versions: null,
};

export const useVersionsStore = create<VersionsState & VersionsAction>(
  (set) => ({
    ...initialState,
    setVersions: (versions: VersionsState['versions']) => set({ versions }),
  }),
);

export const setVersions = (versions: VersionsState['versions']) => {
  useVersionsStore.setState({ versions });
};
